import type { IPopupConfig } from "@similarweb/ui-components";

export const DEFAULT_TOOLTIP_CONFIG: IPopupConfig = {
    cssClass: "Popup-element-wrapper--notification-mode",
    width: "fit-content",
    maxWidth: 310,
    placement: "left-center",
};
